import React from 'react';
import { View } from 'react-native';
import { useTheme } from 'react-native-paper';
import { useTranslation } from 'react-i18next';
import Button from './Button';

const QueueActionButtons = ({
  queueUserDetail,
  isAdmin = false,
  isDirectAccess = false,
  showLeaveQueue = true,
  leaveQueueTxt = 'leave_queue',
  navigation,
  onLeaveQueue,
  onRateExperience,
  onGoToQueueApp,
  user,
  styles,
}) => {
  const theme = useTheme();
  const { t } = useTranslation();

  const isCompleted = queueUserDetail?.status === 'Completed';
  const isRemoved = queueUserDetail?.status === 'Removed';
  const isExited = queueUserDetail?.status === 'Exited';
  const isStaging = queueUserDetail?.status === 'Staging';
  const isServing = queueUserDetail?.status === 'Serving';
  const isBatchQueue = queueUserDetail?.queue_type === 'Batch';

  const canLeaveQueue =
    !isCompleted && !isRemoved && !isExited && !isStaging && !isServing;

  const canRejoin = isRemoved || isExited || isCompleted;
  const canRate = !queueUserDetail?.has_given_review && isCompleted;

  const goToDashboard = () => {
    if (user) {
      navigation.replace('DashboardScreen');
    } else {
      navigation.navigate('SignInScreen');
    }
  };

  // For batch queues, action buttons are handled separately
  if (isBatchQueue) {
    return null;
  }

  return (
    <>
      {/* Leave/Remove Queue Button */}
      {canLeaveQueue && (
        <View style={{ width: '100%' }}>
          {!isDirectAccess && !isAdmin && (
            <Button
              mode="contained"
              style={styles.dashboardBtn}
              onPress={goToDashboard}
            >
              {t('go_to_dashboard')}
            </Button>
          )}
          <Button
            mode="contained"
            style={styles.bgOutlineRed}
            labelStyle={{ color: theme.colors.error }}
            onPress={onLeaveQueue}
          >
            {isAdmin ? t('remove') : t(`${leaveQueueTxt}`)}
          </Button>
        </View>
      )}

      {/* Rejoin and Rate Buttons */}
      {canRejoin && !isAdmin && (
        <View style={{ marginTop: 10, width: '100%' }}>
          <Button
            mode="contained"
            onPress={() => {
              navigation.replace('JoinQueueScreen', {
                qid: queueUserDetail?.queue_id,
              });
            }}
          >
            {t('rejoin_queue')}
          </Button>
          {canRate && (
            <Button
              mode="outlined"
              style={{
                marginTop: 10,
                borderColor: theme.colors.primary,
                backgroundColor: 'transparent',
              }}
              labelStyle={{ color: theme.colors.primary }}
              onPress={onRateExperience}
            >
              {t('rate_experience')}
            </Button>
          )}
        </View>
      )}

      {/* Go to Queue App Button for Direct Access */}
      {isDirectAccess && onGoToQueueApp && (
        <View style={{ marginTop: 5, width: '100%' }}>
          <Button
            mode="contained"
            style={styles.bgBlue}
            onPress={onGoToQueueApp}
          >
            {t('go_to_queue_app')}
          </Button>
        </View>
      )}
    </>
  );
};

export default QueueActionButtons;
